import { render, staticRenderFns } from "./ApplyNo_dets.vue?vue&type=template&id=1328880b&scoped=true&"
import script from "./ApplyNo_dets.vue?vue&type=script&lang=js&"
export * from "./ApplyNo_dets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328880b",
  null
  
)

export default component.exports